export const plTranslations = {
  // Header
  "logo": "Gabriela Nowakowska",
  "nav": {
    "about": "O mnie",
    "experience": "Doświadczenie",
    "publications": "Publikacje",
    "teaching": "Dydaktyka",
    "contact": "Kontakt"
  },
  
  // Hero
  "hero": {
    "badge": "Adiunkt",
    "titlePrefix": "Dr inż.",
    "titleName": "Gabriela Nowakowska",
    "titleSuffix": "",
    "subtitle": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
    "description": "Posiadam doktorat z informatyki i uwielbiam łączyć teorię z praktycznymi zastosowaniami. Obecnie pracuję z Allegro poprzez Laniqo, skupiając się na tłumaczeniu maszynowym dla e-commerce – zasadniczo ułatwiając i zwiększając dostępność globalnych zakupów. Wcześniej pracowałam w Snowflake (dawniej Applica) nad rozumieniem dokumentów, przekształcając nieustrukturyzowane dane w coś użytecznego. Moje badania były prezentowane na międzynarodowych konferencjach, a najbardziej ekscytuje mnie rozwiązywanie rzeczywistych problemów z wykorzystaniem NLP, ML i AI.",
    "contactBtn": "Skontaktuj się",
    "publicationsBtn": "Zobacz publikacje"
  },
  
  // Experience
  "experience": {
    "title": "Wykształcenie i Doświadczenie",
    "workTitle": "Doświadczenie Zawodowe",
    "educationTitle": "Wykształcenie",
    "present": "Teraz",
    "labels": {
      "supervisor": "Promotor:",
      "defenseDate": "Data obrony:",
      "showAbstract": "Pokaż streszczenie",
      "hideAbstract": "Ukryj streszczenie"
    },
    "work1": {
      "title": "Senior Machine Learning Developer",
      "company": "Laniqo",
      "description": "Praca nad tłumaczeniem maszynowym dla e-commerce w celu ułatwienia i zwiększenia dostępności globalnych zakupów."
    },
    "work1Allegro": {
      "title": "Senior MT Research Scientist",
      "company": "Allegro",
      "description": "Praca nad tłumaczeniem maszynowym dla e-commerce w celu ułatwienia i zwiększenia dostępności globalnych zakupów."
    },
    "work2": {
      "title": "Research Scientist",
      "company": "Snowflake (dawniej Applica)",
      "description": "Badania i rozwój w zakresie ekstrakcji informacji z dokumentów biznesowych. Tworzenie modeli wyodrębniających dane w listy i tabele z długich dokumentów oraz budowa systemu zarządzania zbiorami danych usprawniającego przygotowanie i organizację danych."
    },
    "work3": {
      "title": "Deep Learning Specialist",
      "company": "Applica",
      "description": "Badania i rozwój w zakresie ekstrakcji informacji z dokumentów biznesowych. Tworzenie modeli wyodrębniających dane ze struktur (np. listy, tabele), treści nieustrukturyzowanych (tekst) i elementów graficznych (np. podpisy, pieczątki, checkboxy), przygotowanie zbiorów treningowych, testowych i walidacyjnych oraz prowadzenie eksperymentów oceniających i optymalizujących wydajność modeli."
    },
    "edu1": {
      "title": "Doktor Informatyki",
      "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
      "titleEn": "Named entity recognition and information extraction from various documents",
      "titlePl": "Rozpoznawanie jednostek nazwanych i ekstrakcja informacji z dokumentów różnego typu",
      "supervisor": "prof. UAM dr hab. Tomasz Górecki",
      "defenseDate": "14 stycznia 2025"
    },
    "edu2": {
      "title": "Magister Informatyki",
      "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
      "titleEn": "Query expansion using language models",
      "titlePl": "Rozszerzanie zapytań przy użyciu modeli języka",
      "supervisor": "prof. UAM dr hab. Filip Graliński",
      "defenseDate": "30 czerwca 2020"
    },
    "edu3": {
      "title": "Inżynier Informatyki",
      "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
      "titleEn": "Conference Management System - application for simplifying the process of creating and managing conferences",
      "titlePl": "System Obsługi Konferencji - Aplikacja wspomagająca tworzenie i uczestniczenie w konferencjach",
      "supervisor": "prof. UAM dr hab. Krzysztof Dyczkowski",
      "defenseDate": "13 lutego 2019"
    },
    "eduMathMaster": {
      "title": "Magister Matematyki",
      "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
      "titleEn": "Computability concept formalizations",
      "titlePl": "Formalizacje pojęcia obliczalności",
      "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
      "defenseDate": "9 lipca 2019"
    },
    "eduMathBachelor": {
      "title": "Licencjat Matematyki",
      "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
      "titleEn": "Łukasiewicz logic as an example of many valued logic",
      "titlePl": "Logika Łukasiewicza jako przykład logiki wielowartościowej",
      "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
      "defenseDate": "3 lipca 2017"
    }
  },
  
  // Publications
  "publications": {
    "title": "Publikacje",
    "labels": {
      "authors": "Autorzy:",
      "venue": "Miejsce publikacji:",
      "doi": "DOI:",
      "url": "URL:",
      "date": "Data:",
      "showAbstract": "Pokaż streszczenie",
      "hideAbstract": "Ukryj streszczenie"
    }
  },
  
  // Teaching
  "teaching": {
    "title": "Dydaktyka",
    "course1": {
      "title": "Formal Languages and Computational Complexity",
      "polish": "Języki formalne i złożoność obliczeniowa",
      "linkLabel": "Języki formalne i złożoność obliczeniowa (lab.) (2026/SL) (G. Nowakowska)",
      "description": "Ćwiczenia w salach komputerowych skupiają się na praktycznych zastosowaniach automatów skończonych w programowaniu – implementacji wyrażeń regularnych, projektowaniu parserów oraz reprezentacji automatów w strukturach kodu. Studenci uczą się stosować formalne modele obliczeniowe w rzeczywistych zadaniach programistycznych."
    },
    "course2": {
      "title": "Machine Learning",
      "polish": "Uczenie maszynowe",
      "linkLabel": "Uczenie maszynowe (lab.) (2025/SZ) (D. Filipiak, D. Ewald, G. Nowakowska)",
      "description": "Laboratorium koncentruje się na praktycznej implementacji algorytmów uczenia maszynowego w Pythonie z użyciem bibliotek NumPy, PyTorch i Scikit-Learn. Studenci implementują regresję liniową i logistyczną, metody ewaluacji i walidacji krzyżowej, algorytmy uczenia nienadzorowanego oraz sieci neuronowe. Zajęcia kończą się indywidualnym projektem programistycznym."
    }
  },
  
  // Contact
  "contact": {
    "title": "Kontakt",
    "email": "Email: gabriela.nowakowska@amu.edu.pl",
    "emailLabel": "E-mail",
    "consultationTitle": "Konsultacje dla studentów",
    "consultation1": "• Wtorki: 12:00-13:00 (stacjonarnie) - proszę o wcześniejszą wiadomość, inaczej mogę znajdować się w innej części budynku",
    "consultation2": "• Drugi termin jest ruchomy - proszę napisać maila, a umówimy się na konsultację (możliwa konsultacja online przez Microsoft Teams <i class=\"fas fa-video\" style=\"color: #6264A7;\"></i>)",
    "orcid": "ORCID: 0000-0002-5139-2126"
  },
  
  // Page title
  "pageTitle": "Gabriela Nowakowska | Adiunkt",
  "pageTitleExperience": "Doświadczenie | Gabriela Nowakowska",
  "pageTitlePublications": "Publikacje | Gabriela Nowakowska",

  // Footer
  "footer": {
    "copyright": "Gabriela Nowakowska. Wszelkie prawa zastrzeżone.",
    "university": "Uniwersytet im. Adama Mickiewicza w Poznaniu"
  }
}; 